import React, { Component } from 'react';
import * as encryptUtils from "./encryptDecryptUtils";
import * as loggingUtils from "./utils/loggingUtils";

class NextLivestream extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // TODO lots of hardcoded data in this file
    return (
      <div>
        <div className="mt-4 h-auto md:h-112 flex flex-col md:flex md:flex-row justify-start md:items-center md:justify-around w-full md:bg-gradient-to-br md:from-custom-black md:via-zinc-900 md:to-custom-black rounded-xl">
          <video
            onClick={()=> {
              loggingUtils.logEvent(
                this.props.address != null
                  ? this.props.address
                  : encryptUtils.getWalletUnconnectedUserId(),
                "home",
                "home_click_next_livestream",
                "info",
                "https://the402.xyz",
                {}
              );
              window.open(window.location.origin + "/profile/x&nd", "_self")
            }}
            className="h-96 w-full md:w-1/2 object-cover cursor-pointer bg-black rounded-none sm:rounded-xl shadow-[0_4px_20px_rgba(0,0,0,0.4)]"
            src="https://ppv-nft-files.s3.us-west-2.amazonaws.com/QmTM3FW5tt2vdUPaUGU9GZaoDJuoqNHx5VK5UHsJma7H2Z.mp4"
            loop autoplay="autoplay" controls muted
          >
          </video>
          <div className="flex flex-col">
            <div className="mt-2 md:mt-0 text-zinc-500 text-lg lg:text-2xl font-medium">
              X&ND
            </div>
            <div className="mt-1 text-white text-3xl lg:text-6xl font-semibold">
              STUDIO 002
            </div>
            <div className="mt-2 md:mt-8 text-teal-400 text-md sm:text-xl font-semibold">
              LIVE: OCT 13, 8:30PM EST
            </div>
            <div className="cursor-pointer mt-2 md:mt-8 hover:-translate-y-0 sm:hover:scale-105 duration-500 bg-white w-72 md:w-80 lg:w-96 h-14 rounded-lg justify-center flex items-center text-xl font-semibold"
              onClick={()=> {
                window.open(window.location.origin + "/profile/x&nd", "_self")
              }}
            >
              VIEW
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default NextLivestream;
